"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SummaryWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Summary Widget is a rounded-radius box with a title and a value useful for displaying summaries.
 * 
 * The following props should be passed:
 * 
 *  tooltip:    Hover over tooltip value
 *  label:      the title / label which is converted to uppercase
 *  val:        the large value 
 *  
 *  Optional props
 *  
 *  borderColor: color of the border, default to 'gray'
 *  backgroundColor: color of the inside area, default to 'white'
 *  radius: curve radius in pixels, default 5px
 *  valueStyle: style to apply to the value text
 */

var SummaryWidget = exports.SummaryWidget = function SummaryWidget(props) {
  var radius = props.borderRadius ? props.borderRadius + 'px' : '5px';
  var borderColor = props.borderColor ? props.borderColor : 'gray';
  var backgroundColor = props.backgroundColor ? props.backgroundColor : 'white';
  var styles = {
    tooltip: {
      maxWidth: props.tooltipWidth ? props.tooltipWidth : 'none'
    }
  };
  var StyledTooltip = (0, _styles.withStyles)(styles)(_core.Tooltip);
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      border: '1px solid ' + borderColor,
      borderRadius: radius,
      paddingTop: 5,
      paddingBottom: 5,
      background: backgroundColor
    }
  }, /*#__PURE__*/_react["default"].createElement(StyledTooltip, {
    title: props.tooltip ? props.tooltip : ""
  }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    container: true,
    direction: "column",
    alignContent: "center",
    spacing: 0
  }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "body2",
    align: "center"
  }, props.label.toUpperCase())), /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "h5",
    align: "center",
    style: props.valueStyle
  }, props.value)))));
};